export default __webpack_public_path__ + "locales/es/Translations.json?hash=95d5dc29a3de43cc4967213d7ffac4c7";